import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as base_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_athletics",
			options: [
				{
					value: "ATH532",
					text: "Archery"
				},
				{
					value: "ATH999",
					text: "Athletics - Varsity"
				},
				{
					value: "ATH533",
					text: "Badminton"
				},
				{
					value: "ATH101",
					text: "Baseball"
				},
				{
					value: "ATH102",
					text: "Basketball"
				},
				{
					value: "ATH009",
					text: "Bowling"
				},
				{
					value: "ATH534",
					text: "Boxing"
				},
				{
					value: "ATH103",
					text: "Cheerleading"
				},
				{
					value: "ATH505",
					text: "Cricket"
				},
				{
					value: "ATH104",
					text: "Cross Country"
				},
				{
					value: "ATH121",
					text: "Diving"
				},
				{
					value: "ATH005",
					text: "Equestrian"
				},
				{
					value: "ATH008",
					text: "Fencing"
				},
				{
					value: "ATH105",
					text: "Field Hockey"
				},
				{
					value: "ATH106",
					text: "Football"
				},
				{
					value: "ATH107",
					text: "Golf"
				},
				{
					value: "ATH120",
					text: "Gymnastics"
				},
				{
					value: "ATH536",
					text: "Handball"
				},
				{
					value: "ATH108",
					text: "Ice Hockey"
				},
				{
					value: "ATH109",
					text: "Indoor Track"
				},
				{
					value: "ATH012",
					text: "Judo"
				},
				{
					value: "ATH110",
					text: "Lacrosse"
				},
				{
					value: "ATH535",
					text: "Non-Tackle Football"
				},
				{
					value: "ATH999",
					text: "Other Athletics"
				},
				{
					value: "ATH112",
					text: "Outdoor Track"
				},
				{
					value: "ATH537",
					text: "Racquetball"
				},
				{
					value: "ATH522",
					text: "Rifle"
				},
				{
					value: "ATH538",
					text: "Rodeo"
				},
				{
					value: "ATH007",
					text: "Rowing"
				},
				{
					value: "ATH006",
					text: "Rugby"
				},
				{
					value: "ATH119",
					text: "Sailing"
				},
				{
					value: "ATH003",
					text: "Skiing"
				},
				{
					value: "ATH013",
					text: "Skin Diving"
				},
				{
					value: "ATH114",
					text: "Soccer"
				},
				{
					value: "ATH113",
					text: "Softball"
				},
				{
					value: "ATH539",
					text: "Squash"
				},
				{
					value: "ATH115",
					text: "Swim"
				},
				{
					value: "ATH540",
					text: "Synchronized Swimming"
				},
				{
					value: "ATH541",
					text: "Table Tennis"
				},
				{
					value: "ATH116",
					text: "Tennis"
				},
				{
					value: "ATH542",
					text: "Track and Field"
				},
				{
					value: "ATH543",
					text: "Triathlon"
				},
				{
					value: "ATH117",
					text: "Volleyball"
				},
				{
					value: "ATH531",
					text: "Water Polo"
				},
				{
					value: "ATH544",
					text: "Weight Lifting"
				},
				{
					value: "ATH118",
					text: "Wrestling"
				}
			]
		},
		base_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
